import Modal from '@components/v2/ui/Modal/Modal';
import { Divider, Stack } from '@mui/material';
import { CircleAlert } from 'lucide-react';
import { Fragment } from 'react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';
import { BusinessPolicyViolationSection } from '../businessPolicyViolation.types';
import BusinessPolicyViolationConditionSection from './BusinessPolicyViolationConditionSection';
import BusinessPolicyViolationDetails from './BusinessPolicyViolationDetails';

interface BusinessPolicyViolationsModalProps {
  isOpen: boolean;
  onClose: () => void;
  sections: BusinessPolicyViolationSection[];
}

const BusinessPolicyViolationsModal = ({
  isOpen,
  onClose,
  sections,
}: BusinessPolicyViolationsModalProps) => (
  <Modal
    isOpen={isOpen}
    size="expanded"
    testId={OrderConditionsTestIds.POLICY_VIOLATIONS_MODAL}
    header={{ title: LangEnum.ORDER_VALIDATION_POLICY_PENDING, icon: CircleAlert }}
    onClose={onClose}
  >
    <Stack sx={{ gap: 3 }}>
      {sections.map(({ condition, violations }, index) => (
        <Fragment key={condition?.id ?? index}>
          {index > 0 && <Divider />}

          {condition ? (
            <BusinessPolicyViolationConditionSection
              condition={condition}
              violations={violations}
            />
          ) : (
            <BusinessPolicyViolationDetails violations={violations} />
          )}
        </Fragment>
      ))}
    </Stack>
  </Modal>
);

export default BusinessPolicyViolationsModal;
